export default window._;
